<div class="container-reclamations">
  <div class="reclamations">
    <div class="reclamations__titre">
      <h1 class="reclamations__titre__contenu font-bold">réclamations</h1>
    </div>

    <div class="reclamations__questce">
      <p class="reclamations__questce_titre font-bold">
        1. Qu'est-ce qu'une réclamation ?
      </p>

      <div class="reclamations__questce__contenu marginParagraphe">
        <p>
          Une réclamation est une déclaration par laquelle vous manifestez votre
          mécontentement envers notre société, sur un ou des sujets clairement
          identifiés, dans l’application de la convention d’intermédiation.
        </p>
      </div>
    </div>

    <div class="reclamations__commentFaire">
      <p class="reclamations__commentFaire__titre marginParagraphe font-bold">
        2. Comment faire une réclamation ?
      </p>

      <p class="marginParagraphe">La réclamation sous forme d’un écrit :</p>

      <ul class="reclamations__commentFaire__adresse marginParagraphe">
        <li class="reclamations__commentFaire__adresse__premier">
          adressé par
          <span
            class="reclamations__commentFaire__adresse__premier__voie font-bold"
            >voie postale</span
          >
          à l’adresse : <br />MEILLEURTAUX Santé<br />
          Service de traitement des réclamations - 95 rue d’Amsterdam, 75008
          PARIS
        </li>

        <li class="marginParagraphe">
          Ou par mail à l’adresse :
          <a href="mailto:reclamationsante@meilleurtaux.com" class="link-color">
            reclamationsante&#64;meilleurtaux.com
          </a>
        </li>
      </ul>
    </div>

    <div class="reclamations__commentTraiter">
      <div class="reclamations__commentTraiter__titre">
        <p class="marginParagraphe font-bold">
          3. Comment est traitée votre réclamation ?
        </p>

        <p class="marginParagraphe">
          Nous nous engageons à accuser réception de votre réclamation dans un
          délai maximum de 10 jours ouvrables à compter de sa réception. Nous
          nous engageons à vous apporter une réponse (positive ou négative) dans
          un délai de 2 mois à compter de la réception de la totalité des
          éléments de votre réclamation.
        </p>

        <p
          class="marginParagraphe reclamations__commentTraiter__titre__satisfaction"
        >
          Si vous n’êtes pas satisfait de notre réponse ou en l’absence de
          réponse dans un délai de deux (2) mois, vous pouvez saisir le
          médiateur de l’assurance :
        </p>

        <ul class="reclamations__commentTraiter__voie">
          <li>
            par voie électronique en complétant le formulaire disponible sur le
            site internet suivant :
            <a
              href="https://www.mediation-assurance.org"
              target="blank"
              class="reclamations__commentTraiter__voie__link link-color"
              >https://www.mediation-assurance.org</a
            >
          </li>

          <li>
            par courrier à l’adresse suivante : La Médiation de l’Assurance -
            TSA 50110 - 75441 Paris Cedex 09.
          </li>
        </ul>

        <p class="marginParagraphe">Le Médiateurs ne pourra intervenir que :</p>

        <ul class="reclamations__commentTraiter__voie">
          <li>
            Si le réclamant a préalablement formulé une réclamation écrite
          </li>

          <li>
            Si le réclamant effectue sa saisine dans le délai d’un (1) an après
            cette réclamation écrite.
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<wz-footer-demande-devis></wz-footer-demande-devis>
